import React, { type JSX } from 'react';
import { ThemeProvider } from 'styled-components';

import { RoverBrand } from '@rover/types/src/RoverBrand';

import { BrandThemeProviderProps, useBrandThemeMemo } from './BrandThemeProvider.common';

/**
 * Provides a React Context with the appropriate theme object for the `brand` prop.
 * Defaults to the `rover` brand if not specified.
 */
const BrandThemeProvider = ({
  brand = RoverBrand.Rover,
  children,
}: BrandThemeProviderProps): JSX.Element => {
  const theme = useBrandThemeMemo(brand);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default BrandThemeProvider;
